export default __webpack_public_path__ + "99f4d5ae46d181b817a3a0040c5c4f98.png";